import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-bell-curve-tooltip',
  templateUrl: './m-bell-curve-tooltip.component.html',
  styleUrls: ['./m-bell-curve-tooltip.component.scss']
})
export class MBellCurveTooltipComponent {
  @Input() metricValue!: string;
  @Input() lowerBound!: string;
  @Input() upperBound!: string;
  @Input() statisticalSignificance!: string;
}
